import * as React from "react";
import * as ReactDOM from "react-dom";
import { Sounds } from "source/app/services/Sound/Sounds";
import { HSLColors } from "source/app/services/UI/Background/Texture/Helpers/HSLColor";
import { Texture } from "source/app/services/UI/Background/Texture/Texture";
import { HandleError } from "source/app/presentation/Shared/HandleError";
import { BannerImages } from "../../../../../services/Shared/RenderSwal/BannerImage/BannerImage";
import RenderSwal, {
    TSwalOptions,
} from "../../../../../services/Shared/RenderSwal/RenderSwal";
import { SwalButtons } from "../../../../../services/Shared/RenderSwal/SwalBody/SwalButtons";
import { ETexture } from "../../../../../services/UI/Background/Texture/ETexture";
import IDream from "motw_core/Entity/IDream";
import {
    AddAction,
    DreamEditor,
    GetEditorTitle,
    UpdateAction,
} from "../DreamEditor";
import { GetEditedDream } from "../Helpers/GetEditedDream";
import { DreamType } from "../DreamType";
import { PrepareCopiedDream } from "source/app/presentation/MainPanel/Dreams/DreamEditor/Helpers/PrepareCopiedDream";
const cashJS = require("cash-dom");

export const LaunchDreamEditor = async (
    dreamType: DreamType,
    dream: IDream | {},
    allDreams: IDream[],
    intitializedDreamProperties?: Partial<IDream>
) => {
    if (!allDreams) throw new Error("Missing inputs");

    let inputDream = dream as IDream;

    if (dreamType === DreamType.Copied) {
        inputDream = PrepareCopiedDream(inputDream);
    }

    const swalOptions: TSwalOptions = {
        title: GetEditorTitle(dreamType, dream as IDream),
        preConfirm: () => {
            const dream = GetEditedDream();
            if (!dream.name || !dream.difficulty || !dream.emotion) {
                toastr.error(
                    "Dream name, difficulty and emotion must be provided"
                );
                return false;
            }
        },
        bannerImage: BannerImages.minerals,
        height: `450px`,
        background: new Texture({
            image: ETexture.gplay,
            backgroundColor: HSLColors.transparent,
        }).combinedCSS.background as string,
    };

    try {
        Sounds.chimes_varied_short.Play();

        RenderSwal(
            swalOptions,
            <DreamEditor
                dreamType={dreamType}
                dream={inputDream}
                allDreams={allDreams}
                initializedDreamProperties={intitializedDreamProperties}
            />,
            dreamType === DreamType.Existing ? UpdateAction : AddAction,
            () => {}
        );

        if (dreamType === DreamType.Existing) {
            AddSaveButton();
        }
    } catch (e) {
        HandleError(e);
    }
};

function AddSaveButton() {
    cashJS("#swalButtons-target").prepend(`<span id='swal2-saveButton' />`);

    ReactDOM.render(
        <SwalButtons.Save
            onClick={() => {
                Sounds.metal_swipe.Play();
                UpdateAction(true);
            }}
        />,
        document.getElementById("swal2-saveButton")
    );
}
